import {DialogConsumerContentDefaultBox} from './dialog-consumer-content.default.box';

export const DialogConsumerContentBox = DialogConsumerContentDefaultBox;